import React from 'react'
import { clsx } from 'clsx'
import { classToFComponent, type FCClassContext } from 'cube-react'

import Sel from '@/shared/view/CssSelectors'
import { Container, Col, Row, BrCard } from '@govbr-ds/react-components'

import { HomeScope } from '../main.scope'

export type HomeProps = {
    className?: string
    scope: HomeScope
}

export class HomeViewClass implements FCClassContext<HomeProps> {
    render({ className }: HomeProps) {
        return (
            <Container className={clsx(className)}>
                <Row>
                    <Col>
                        <h1 className={clsx(Sel.textUp04, Sel.textWeightBold, Sel.mb('4x'), Sel.textPrimary)}>
                            Bem-vindo ao BulaCerta AI
                        </h1>
                    </Col>
                </Row>

                <Row>
                    <Col md={8}>
                        <p className={clsx(Sel.textLg, Sel.mb('2x'))}>
                            Uma plataforma inteligente que transforma a maneira como profissionais de saúde e pacientes
                            acessam informações farmacêuticas.
                        </p>
                        <p>
                            O <strong>BulaCerta AI</strong> utiliza algoritmos avançados de Inteligência Artificial e
                            Large Language Models (LLMs) para extrair e organizar dados diretamente de bulas
                            regulamentadas pela ANVISA. Nossa solução vai além da simples leitura: ela interpreta
                            dúvidas em linguagem natural sobre
                            <strong>
                                posologia, interações medicamentosas, contraindicações e efeitos colaterais
                            </strong>
                            .
                        </p>
                        <br />
                        <p>
                            Desenvolvido pela <strong>Lifeshub</strong>, o sistema visa reduzir erros médicos, otimizar
                            a tomada de decisão clínica e aumentar a segurança do paciente, centralizando informações
                            críticas em uma interface acessível e intuitiva.
                        </p>
                    </Col>

                    <Col md={4}>
                        <BrCard>
                            <div className={clsx(Sel.textWeightSemiBold, Sel.textUp01, Sel.mb('base'))}>
                                Destaques da Plataforma
                            </div>
                            <ul className={Sel.lifeshubList}>
                                <li>
                                    🔍 <strong>Consulta Inteligente:</strong> Respostas diretas baseadas em bulas
                                    oficiais.
                                </li>
                                <li>
                                    💊 <strong>Segurança:</strong> Detecção de riscos e interações.
                                </li>
                                <li>
                                    📱 <strong>Acessibilidade:</strong> Disponível Web e Mobile.
                                </li>
                                <li>
                                    🔗 <strong>Integração:</strong> APIs para sistemas hospitalares.
                                </li>
                            </ul>
                        </BrCard>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default classToFComponent<HomeProps>(HomeViewClass)
